import dayjs from 'dayjs'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import { isIOS } from './utils'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
dayjs.extend(utc)
dayjs.extend(timezone)

const legacyToCanonicalMap = {
  'Asia/Calcutta': 'Asia/Kolkata',
  // Add other mappings if needed
};

//gived difference between 2 dates in days
export const dateDiffInDays = (endDate, startDate) => {
  const start = dayjs(startDate)
  const end = dayjs(endDate)
  const days = end.diff(start, 'days')
  return days
}

//gived difference between 2 dates in hours
export const dateDiffInHours = (endDate, startDate) => {
  const start = dayjs(startDate)
  const end = dayjs(endDate)
  const hours = end.diff(start, 'hour')
  return hours
}

export const dateDiffInMinutes = (endDate, startDate) => {
  const start = dayjs(startDate)
  const end = dayjs(endDate)
  const mins = end.diff(start, 'minute')
  return mins
}
export const dateDiffInSeconds = (endDate, startDate) => {
  const start = dayjs(startDate)
  const end = dayjs(endDate)
  const mins = end.diff(start, 'second')
  return mins
}

export const dateDiffInWeeks = (endDate, startDate) => {
  const start = dayjs(startDate)
  const end = dayjs(endDate)
  const weeks = end.diff(start, 'week')
  return weeks
}

export const dateDiffInMonths = (endDate, startDate) => {
  const start = dayjs(startDate)
  const end = dayjs(endDate)
  const months = end.diff(start, 'month')
  return months
}

//gived difference between 2 dates in years
export const dateDiffInYears = (endDate, startDate) => {
  const start = dayjs(startDate)
  const end = dayjs(endDate)
  const years = end.diff(start, 'years')
  return years
}

export const formatDate = (date, format) => {
  return dayjs(date).format(format)
}

export const formatUnixTimestampToDate = (date, format) => {
  return dayjs.unix(date).format(format)
}

//format the date in given format param
export const formatLastUpdateDate = (date, format = '', t) => {
  if (!date) {
    return ''
  }
  if (!(date instanceof Date)) {
    date = parseUTC(date)
  }

  let dayOfMonth = date.getDate()
  let month = date.getMonth() + 1
  let hour = date.getHours()
  let minutes = date.getMinutes()
  let seconds = date.getSeconds()

  // formatting

  month = month < 10 ? `0${month}` : month
  dayOfMonth = dayOfMonth < 10 ? `0${dayOfMonth}` : dayOfMonth
  hour = hour < 10 ? `0${hour}` : hour
  minutes = minutes < 10 ? `0${minutes}` : minutes
  seconds = seconds < 10 ? `0${seconds}` : seconds

  const diffMs = new Date() - date
  const diffSec = Math.round(diffMs / 1000)
  const diffMin = diffSec / 60
  const diffHour = diffMin / 60
  const diffDay = diffHour / 24

  const isCurrentYr = isCurrentYear(date)

  if (format) {
    return formatDate(date, format)
  } else {
    if (diffSec < 90) {
      // less than a min  e.g //a min ago
      return t('global.nminsAgo', { count: 1 })
    } else if (diffSec >= 90 && diffMin < 45) {
      // between 1 min and 45 mins e.g. 10 mins ago
      return t('global.nminsAgo', { count: Math.round(diffMin) })
    } else if (diffMin >= 45 && diffMin < 90) {
      // between 45 mins and 90 mins e.g. 1 hr ago
      return t('global.nhrsAgo', { count: 1 })
    } else if (diffMin >= 90 && diffHour < 24) {
      // between 1.5 hr and 24 hrs e.g. 3 hrs ago
      const diffHourInt = Math.round(diffHour)
      return t('global.nhrsAgo', { count: diffHourInt })
    } else if (diffHour >= 24 && diffDay < 7) {
      const diffDayInt = Math.round(diffDay)
      return t('global.nDayAgo', { count: diffDayInt })
    } else if (diffDay >= 7) {
      if (isCurrentYr) {
        return formatDate(date, getDateFormat4())
      }
      return formatDate(date, getDateFormat2()) // displays full date without time
    }
  }
}

//format two dates(start and end date) in "date1 - date2" format. ex: 22 Oct, 2022 - 23 Oct, 2022
export const showTwoFormattedDates = (startDate, endDate, format) => {
  return `${formatDate(startDate, format)} - ${formatDate(endDate, format)}`
}

export const showTwoFormattedDates2 = (startDate, endDate, format = getDateFormat4()) => {
  return `${formatDate(startDate, format)} - ${formatDate(endDate, format)}`
}

export const convertTo12hrFormat = (timeString) => {
  const timeString12hr = new Date('1970-01-01T' + timeString + 'Z').toLocaleTimeString('en-US', {
    timeZone: 'UTC',
    hour12: true,
    hour: 'numeric',
    minute: 'numeric'
  })
  return timeString12hr
}

export const getTime = (date, type) => {
  if (!(date instanceof Date)) {
    date = convertPhpDate(date)
  }
  let hours = date.getHours()
  let minutes = date.getMinutes()

  var ampm = hours >= 12 ? 'pm' : 'am'
  hours = hours % 12
  hours = hours ? hours : 12 // the hour '0' should be '12'
  minutes = minutes < 10 ? '0' + minutes : minutes
  var strTime = hours + ':' + minutes + ' ' + ampm
  return strTime
}

export const convertToLocalDate = (date) => {
  return new Date(`${date} UTC`)
}
export const convertDateForIos = (date) => {
  const arr = date.split(/[- :]/)
  date = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5])
  return date
}

export const parseUTC = (s) => {
  var b = s.split(/\D/)
  return new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5]))
}
export const convertPhpDate = (date) => {
  return isIOS() ? convertDateForIos(date) : new Date(date)
}

export const diffWeeks = (date2, date1) => {
  let diff = (date2.getTime() - date1.getTime()) / 1000
  diff /= 60 * 60 * 24 * 7
  return Math.abs(Math.round(diff))
}

export const timeConverter = (timestamp, format = 'en') => {
  const a = new Date(timestamp * 1000)
  const year = a.getFullYear()
  const month = a.getMonth() + 1
  const date = a.getDate()
  let time
  if (format == 'en') time = `${month}/${date}/${year}`
  if (format == 'fr') time = `${date}/${month}/${year}`
  return time
}

export const convertTo24HourFormat = (time12h) => {
  const [time, modifier] = time12h.split(' ')
  let [hours, minutes] = time.split(':')
  if (hours === '12') {
    hours = '00'
  }
  if (modifier === 'PM') {
    hours = parseInt(hours, 10) + 12
  }
  return `${hours}:${minutes}`
}

export const convertUTCToTimezone = (datetime, tz, dateFormat) => {
  if (dateFormat) {
    return dayjs.utc(datetime).utcOffset(tz).format(dateFormat)
  } else {
    return dayjs.utc(datetime).utcOffset(tz)
  }
}

export const isCurrentYear = (date) => {
  const today = new Date()
  return date.getFullYear() == today.getFullYear()
}

export const isToday = (date) => {
  const today = new Date()
  return (
    date.getFullYear() == today.getFullYear() &&
    date.getMonth() == today.getMonth() &&
    date.getDate() == today.getDate()
  )
}

export const isTomorrow = (date) => {
  const today = new Date()
  const tomorrow = new Date(today)
  tomorrow.setDate(tomorrow.getDate() + 1)
  return (
    date.getFullYear() == tomorrow.getFullYear() &&
    date.getMonth() == tomorrow.getMonth() &&
    date.getDate() == tomorrow.getDate()
  )
}

export const isYesterday = (date) => {
  const yesterdayDate = new Date()
  yesterdayDate.setDate(yesterdayDate.getDate() - 1)

  if (yesterdayDate.toDateString() === date.toDateString()) {
    return true
  }
  return false
}

export function roundTimeQuarterHour(currentDateTime = new Date(), hourCount = 0) {
  currentDateTime.setHours(currentDateTime.getHours() + Math.ceil(currentDateTime.getMinutes() / 60))
  currentDateTime.setMinutes(0, 0, 0)
  const min = currentDateTime.getMinutes() < 10 ? `0${currentDateTime.getMinutes()}` : currentDateTime.getMinutes()

  let intHrs = currentDateTime.getHours()
  if (hourCount > 0) {
    intHrs = intHrs + hourCount > 23 ? intHrs + (hourCount % 24) : intHrs + hourCount
  }
  let hrs = intHrs < 10 ? `0${intHrs}` : intHrs.toString()
  return `${hrs}:${min}`
}

export function isPastDate(inputDate, type) {
  const currentDate = new Date()
  let date = inputDate
  if (type === 'string') {
    date = new Date(inputDate)
  }
  return date < currentDate
}

export function isSameDate(endDate, startDate) {
  const startDateObj = new Date(startDate)
  const endDateObj = new Date(endDate)
  return startDateObj?.getDate() === endDateObj?.getDate()
}

export function isSameMonth(endDate, startDate) {
  const startDateObj = new Date(startDate)
  const endDateObj = new Date(endDate)
  return startDateObj?.getMonth() === endDateObj?.getMonth()
}

export function isPastDateWithTZ(inputDate, timezone) {
  let isValid = false
  if (inputDate && timezone) {
    let currentDateTime = new Date().getTime()
    const converted = convertUTCToTimezone(currentDateTime, timezone.utc_offset || timezone.UTCOffset)
    const currentTZDateTime = new Date(
      `${converted.year()}-${converted.month() + 1}-${converted.date()} ${converted.hour()}:${converted.minute()}`
    ).getTime()

    const originalInputDate = new Date(inputDate)
    const inputTZDateTime = new Date(
      `${originalInputDate.getFullYear()}-${
        originalInputDate.getMonth() + 1
      }-${originalInputDate.getDate()} ${originalInputDate.getHours()}:${originalInputDate.getMinutes()}`
    ).getTime()

    if (inputTZDateTime < currentTZDateTime) {
      isValid = true
    }
  }
  return isValid
}

export const getTimezoneAbbreviation = (date) => {
  date = date.toString()
  let timezone = date.match(/\(.+\)/g)[0]
  timezone = timezone.replace('(', '').replace(')', '')
  let abbreviation = ''
  timezone.split(' ').forEach((word) => {
    abbreviation += word.split('')[0]
  })
  return abbreviation
}

export const getTimezone = () => {
  const tz = dayjs.tz.guess();
  return legacyToCanonicalMap[tz] || tz;
}

export const isValidDate = (date) => {
  return date instanceof Date && !isNaN(date)
}

export const isTimeDiffLessThanMinute = (date1, date2) => {
  if (!(date2 instanceof Date)) {
    // date2 = convertPhpDate(date2)

    // if (!isIOS()) {
    date2 = convertToLocalDate(date2)
    // }
  }
  if (!(date1 instanceof Date)) {
    // date1 = convertPhpDate(date1)

    // if (!isIOS()) {
    date1 = convertToLocalDate(date1)
    // }
  }

  const diffMs = date2 - date1
  const diffSec = Math.round(diffMs / 1000)
  return diffSec <= 60
}

export const isTimeDiffLessThan12h = (date1, date2) => {
  if (!(date2 instanceof Date)) {
    // date2 = convertPhpDate(date2)

    // if (!isIOS()) {
    date2 = convertToLocalDate(date2)
    // }
  }
  if (!(date1 instanceof Date)) {
    // date1 = convertPhpDate(date1)

    // if (!isIOS()) {
    date1 = convertToLocalDate(date1)
    // }
  }
  const diffMs = date2 - date1
  const diffHour = Math.ceil(diffMs / 3600000)
  return diffHour <= 12
}

export const getDateFormat1 = () => {
  const lang = localStorage.getItem('current_lang') || appConstantSettings.DEFAULT_LANGUAGE
  if (lang === 'fr') {
    return appConstantSettings.FR_DATE_FORMAT1
  }
  return appConstantSettings.EN_DATE_FORMAT1
}

export const getDateFormat2 = () => {
  const lang = localStorage.getItem('current_lang') || appConstantSettings.DEFAULT_LANGUAGE
  if (lang === 'fr') {
    return appConstantSettings.FR_DATE_FORMAT2
  }
  return appConstantSettings.EN_DATE_FORMAT2
}

export const getDateFormat3 = () => {
  const lang = localStorage.getItem('current_lang') || appConstantSettings.DEFAULT_LANGUAGE
  if (lang === 'fr') {
    return appConstantSettings.FR_DATE_FORMAT3
  }
  return appConstantSettings.EN_DATE_FORMAT3
}
export const getDateFormat4 = () => {
  const lang = localStorage.getItem('current_lang') || appConstantSettings.DEFAULT_LANGUAGE
  if (lang === 'fr') {
    return appConstantSettings.FR_DATE_FORMAT4
  }
  return appConstantSettings.EN_DATE_FORMAT4
}
export const getDateFormat6 = () => {
  const lang = localStorage.getItem('current_lang') || appConstantSettings.DEFAULT_LANGUAGE
  if (lang === 'fr') {
    return appConstantSettings.FR_DATE_FORMAT6
  }
  return appConstantSettings.EN_DATE_FORMAT6
}

export const getDateFormat9 = () => {
  const lang = localStorage.getItem('current_lang') || appConstantSettings.DEFAULT_LANGUAGE
  if (lang === 'fr') {
    return appConstantSettings.FR_DATE_FORMAT9
  }
  return appConstantSettings.EN_DATE_FORMAT9
}

export const getDateFormat10 = () => {
  const lang = localStorage.getItem('current_lang') || appConstantSettings.DEFAULT_LANGUAGE
  if (lang === 'fr') {
    return appConstantSettings.FR_DATE_FORMAT10
  }
  return appConstantSettings.EN_DATE_FORMAT10
}

export const getDateTimeFormat11 = () => {
  const lang = localStorage.getItem('current_lang') || appConstantSettings.DEFAULT_LANGUAGE
  if (lang === 'fr') {
    return appConstantSettings.FR_DATETIME_FORMAT11
  }
  return appConstantSettings.EN_DATETIME_FORMAT11
}

export const getTimeFormat1 = () => {
  const lang = localStorage.getItem('current_lang') || appConstantSettings.DEFAULT_LANGUAGE
  if (lang === 'fr') {
    return appConstantSettings.FR_TIME_FORMAT
  }
  return appConstantSettings.EN_TIME_FORMAT1
}
export const getTimeFormat2 = () => {
  const lang = localStorage.getItem('current_lang') || appConstantSettings.DEFAULT_LANGUAGE
  if (lang === 'fr') {
    return appConstantSettings.FR_TIME_FORMAT
  }
  return appConstantSettings.EN_TIME_FORMAT2
}

/// 14 Nov // FR: nov. 14
export const getFirstDayMonthOfWeek = (date) => {
  const lang = localStorage.getItem('current_lang') || appConstantSettings.DEFAULT_LANGUAGE
  const dateFormat = dayjs(date).toDate()
  if (lang === 'fr') {
    return `<span>${dayjs(dateFormat).startOf('week').format(appConstantSettings.DAY)}</span> ${dayjs(dateFormat)
      .startOf('week')
      .format(appConstantSettings.MONTH)}`
  }
  return `${dayjs(dateFormat).startOf('week').format(appConstantSettings.MONTH)} <span>${dayjs(dateFormat)
    .startOf('week')
    .format(appConstantSettings.DAY)}</span>`
}

/// 14 Nov // FR: nov. 14
export const getLastDayMonthOfWeek = (date) => {
  const lang = localStorage.getItem('current_lang') || appConstantSettings.DEFAULT_LANGUAGE
  const dateFormat = dayjs(date).toDate()
  if (lang === 'fr') {
    return `<span>${dayjs(dateFormat).endOf('week').format(appConstantSettings.DAY)}</span> ${dayjs(dateFormat)
      .endOf('week')
      .format(appConstantSettings.MONTH)}`
  }
  return `${dayjs(dateFormat).endOf('week').format(appConstantSettings.MONTH)} <span>${dayjs(dateFormat)
    .endOf('week')
    .format(appConstantSettings.DAY)}</span>`
}

/// Mon January 10 //FR: lun. 10 janvier
export const getSingleDateFormat = (date) => {
  const lang = localStorage.getItem('current_lang') || appConstantSettings.DEFAULT_LANGUAGE
  const dateObj = dayjs(date)
  let month = dateObj.format(appConstantSettings.MONTH)
  let dayNo = dateObj.format(appConstantSettings.DAY)
  let day = dateObj.format(appConstantSettings.WEEKDAY_FULL)
  if (lang === 'fr') {
    return `<span>${day}</span> ${dayNo} ${month}`
  }
  return `<span>${day}</span> ${month} ${dayNo}`
}

/// Mon Jan, 12 //FR: lun. 12 janv.
export const getCustomFormat1 = (date, utcOffset) => {
  const lang = localStorage.getItem('current_lang') || appConstantSettings.DEFAULT_LANGUAGE
  const weekday =
    lang === 'fr'
      ? convertUTCToTimezone(date, utcOffset, appConstantSettings.WEEKDAY)
      : convertUTCToTimezone(date, utcOffset, `${appConstantSettings.WEEKDAY},`)
  const day = convertUTCToTimezone(date, utcOffset, appConstantSettings.DAY_ZERO_PADDED)
  const month = convertUTCToTimezone(date, utcOffset, appConstantSettings.MONTH)
  return lang === 'fr' ? `${weekday} <span>${day}</span> ${month}` : `${weekday} ${month} <span>${day}</span>`
}
//for screen reader
export const getCustomFormat1_SR = (date, utcOffset) => {
  const lang = localStorage.getItem('current_lang') || appConstantSettings.DEFAULT_LANGUAGE
  let weekday = ''
  let day = ''
  let month = ''

  if (utcOffset) {
    weekday = convertUTCToTimezone(date, utcOffset, appConstantSettings.WEEKDAY_FULL)
    day = convertUTCToTimezone(date, utcOffset, appConstantSettings.DAY)
    month = convertUTCToTimezone(date, utcOffset, appConstantSettings.MONTH_FULL)
  } else {
    weekday = formatDate(date, appConstantSettings.WEEKDAY_FULL)
    day = formatDate(date, appConstantSettings.DAY)
    month = formatDate(date, appConstantSettings.MONTH_FULL)
  }
  return lang === 'fr' ? `${weekday} ${day} ${month}` : `${weekday} ${month} ${day}`
}

/// Mon,    lun.
///  12      12
/// Jan     janv.
export const getCustomFormat2 = (date, date2, utcOffset) => {
  const localStartDate = convertUTCToTimezone(date, utcOffset)
  const localEndDate = convertUTCToTimezone(date2, utcOffset)
  const isMultipleDayMixr = !isSameDate(localEndDate, localStartDate)
  const isMonthSame = isSameMonth(localEndDate, localStartDate)
  const lang = localStorage.getItem('current_lang') || appConstantSettings.DEFAULT_LANGUAGE
  // const weekday =
  //   lang === 'fr'
  //     ? convertUTCToTimezone(date, utcOffset, appConstantSettings.WEEKDAY)
  //     : convertUTCToTimezone(date, utcOffset, `${appConstantSettings.WEEKDAY}${daysDiff == 0 ? ',' : ''}`)

  // const weekday2 =
  //   lang === 'fr'
  //     ? convertUTCToTimezone(date2, utcOffset, appConstantSettings.WEEKDAY)
  //     : convertUTCToTimezone(date2, utcOffset, `${appConstantSettings.WEEKDAY},`)
  const day = convertUTCToTimezone(date, utcOffset, appConstantSettings.DAY_ZERO_PADDED)
  const day2 = convertUTCToTimezone(date2, utcOffset, appConstantSettings.DAY_ZERO_PADDED)
  const month = convertUTCToTimezone(date, utcOffset, appConstantSettings.MONTH)
  const month2 = convertUTCToTimezone(date2, utcOffset, appConstantSettings.MONTH)

  // return `<span class=${daysDiff > 0 ? 'day2' : 'day'}>${
  //   daysDiff > 0 ? `${weekday} - ${weekday2}` : weekday
  // }</span><span class=${daysDiff > 0 ? 'date2' : 'date'}>${
  //   daysDiff > 0 ? `${day} - ${day2}` : day
  // }</span><span class='month'>${month}</span>`

  return `<span class=${isMultipleDayMixr ? 'date2' : 'date'}>${
    isMultipleDayMixr ? `${day} - ${day2}` : day
  }</span><span class=${!isMonthSame ? 'month2' : 'month'}>${!isMonthSame ? `${month} - ${month2}` : month}</span>`
}

export const getDateFormatRange1 = (startdate, enddate) => {
  return `${formatDate(startdate, getDateFormat4())}-${formatDate(enddate, getDateFormat4())}`
}

export const isEventTimeDiffLessThan5minutes = (eventStartDateTime, thresholdMinutes) => {
  const eventStartDate = dayjs(convertToLocalDate(eventStartDateTime))
  const currentDate = dayjs()

  // Check if the event is on the same day as the current date
  const isSameDay = isToday(convertToLocalDate(eventStartDateTime))

  if (isSameDay) {
    // Calculate the time difference in minutes
    const timeDifference = eventStartDate.diff(currentDate, 'minute')
    // Check if the event is less than the specified threshold in minutes
    return timeDifference <= thresholdMinutes
  }

  return false
}

export const getCustomDateFormat = (startDate, endDate, utcOffset, t, dateFormat = getDateFormat4()) => {
  let customDateFormat = getCustomFormat1(startDate, utcOffset)
  const dtStartDate = new Date(startDate)
  const dtEndDate = new Date(endDate)
  const isMultipleDayMixr = !isSameDate(endDate, startDate)
  if (isToday(dtStartDate)) {
    customDateFormat = `${t('global.today')}${
      isMultipleDayMixr ? ` - ${formatLastUpdateDate(dtEndDate, dateFormat)}` : ''
    }`
  } else if (isTomorrow(dtStartDate)) {
    customDateFormat = `${t('global.tomorrow')}${
      isMultipleDayMixr ? ` - ${formatLastUpdateDate(dtEndDate, dateFormat)}` : ''
    }`
  } else if (isMultipleDayMixr) {
    customDateFormat = showTwoFormattedDates2(dtStartDate, dtEndDate, dateFormat)
  }
  return customDateFormat
}

export const convertToMinutes = (value, unit) => {
  switch (unit) {
    case 'day':
      return value * 24 * 60
    case 'hour':
      return value * 60
    case '4hours':
      return value * 4 * 60
    default:
      return NaN
  }
}
